import { Roles } from '../enums/RoleEnums';
import { Types } from '../enums/TypeEnums';
import { UserType } from '../models/appContext';

type optionTypes = {
  [key: string]: {
    create: string[];
    edit: string[];
    delete: string[];
  };
};

const allRoles = [
  Roles.Admin,
  Roles.InvoiceEditor,
  Roles.EsgOperator,
  Roles.IndexOperator,
  Roles.Operator,
  Roles.MarketingOperator
];

const crudRights: optionTypes = {
  Product: {
    create: [Roles.Admin],
    edit: [Roles.Admin],
    delete: [Roles.Admin]
  },
  Company: {
    create: [Roles.Admin, Roles.InvoiceEditor],
    edit: [Roles.Admin, Roles.InvoiceEditor],
    delete: [Roles.Admin, Roles.InvoiceEditor]
  },
  Membership: {
    create: [Roles.Admin, Roles.InvoiceEditor],
    edit: [Roles.Admin, Roles.InvoiceEditor],
    delete: [Roles.Admin, Roles.InvoiceEditor]
  },
  Invoice: {
    create: [Roles.Admin, Roles.InvoiceEditor],
    edit: [Roles.Admin, Roles.InvoiceEditor],
    delete: [Roles.Admin, Roles.InvoiceEditor]
  },
  Contact: {
    create: [Roles.Admin, Roles.InvoiceEditor],
    edit: [Roles.Admin, Roles.InvoiceEditor],
    delete: [Roles.Admin, Roles.InvoiceEditor]
  },
  Template: {
    create: [...allRoles],
    delete: [Roles.Admin, Roles.MarketingOperator],
    edit: [...allRoles]
  },
  RecipientList: {
    create: [...allRoles],
    edit: [...allRoles],
    delete: [Roles.Admin, Roles.MarketingOperator]
  },
  Scheduler: {
    create: [Roles.Admin, Roles.IndexOperator, Roles.MarketingOperator],
    delete: [Roles.Admin, Roles.IndexOperator, Roles.MarketingOperator],
    edit: [Roles.Admin, Roles.IndexOperator, Roles.MarketingOperator]
  },
  CalendarEvent: {
    create: [Roles.Admin, Roles.InvoiceEditor, Roles.IndexOperator, Roles.MarketingOperator],
    delete: [Roles.Admin, Roles.InvoiceEditor, Roles.IndexOperator, Roles.MarketingOperator],
    edit: [Roles.Admin, Roles.InvoiceEditor, Roles.IndexOperator, Roles.MarketingOperator]
  },
  Etf: {
    create: [Roles.Admin, Roles.IndexOperator],
    delete: [Roles.Admin, Roles.IndexOperator],
    edit: [Roles.Admin, Roles.IndexOperator]
  },
  Stock: {
    create: [Roles.Admin, Roles.IndexOperator],
    delete: [Roles.Admin, Roles.IndexOperator],
    edit: [Roles.Admin, Roles.IndexOperator]
  },
  Index: {
    create: [Roles.Admin, Roles.IndexOperator],
    delete: [Roles.Admin, Roles.IndexOperator],
    edit: [Roles.Admin, Roles.IndexOperator]
  },
  IndexSerie: {
    create: [Roles.Admin, Roles.IndexOperator],
    delete: [Roles.Admin, Roles.IndexOperator],
    edit: [Roles.Admin, Roles.IndexOperator]
  }
};

const restrictedTypes = [
  Types.Membership,
  Types.Company,
  Types.Contact,
  Types.Invoice,
  Types.Product,
  Types.Template,
  Types.RecipientList,
  Types.Scheduler,
  Types.CalendarEvent,
  Types.ETF,
  Types.Stock,
  Types.Index,
  Types.IndexSeries
];

const canPerformAction = (userRoles: string[], allowedRoles: string[]): boolean => {
  const result = userRoles?.some((r) => allowedRoles.includes(r));
  return result ?? false;
};

export const canUserDelete = (user: UserType, item: string | undefined): boolean => {
  if (item && restrictedTypes.includes(item as Types)) {
    const allowedRoles = crudRights[item]?.delete || [];
    return canPerformAction(user.data?.roles as string[], allowedRoles);
  }
  return true;
};

export const canUserCreate = (user: UserType, item: string): boolean => {
  const allowedRoles = crudRights[item]?.create || [];
  return canPerformAction(user.data?.roles as string[], allowedRoles);
};

export const canUserEdit = (user: UserType, item: string): boolean => {
  const allowedRoles = crudRights[item]?.edit || [];
  return canPerformAction(user.data?.roles as string[], allowedRoles);
};
